import React from 'react';

import { ModalMobile } from 'components/Atoms';

import { HeaderSearch } from '../HeaderSearch';
import { PlaceItem } from '../PlacesItem';
import * as T from './interfaces';
import * as S from './styles';

export const SearchContainer = ({
  ref,
  children,
  heightHeader,
  placeSelected,
  isMobileDevice,
  mapMode,
  noScroll,
  openModal,
  handleModal,
  ...rest
}: T.ISearchContainerProps) => (
  <S.SearchWrapper
    id="searchPlacesContainer"
    data-testid="searchPlacesContainer"
  >
    <S.SearchList
      id="searchList"
      mapMode={mapMode}
      noScroll={noScroll}
      {...rest}
      ref={ref}
    >
      <S.ItemHeader mapMode={mapMode} isMobileDevice={isMobileDevice}>
        <HeaderSearch wrapperHeight={heightHeader} />
      </S.ItemHeader>
      {children}
    </S.SearchList>
    {mapMode && (
      <ModalMobile
        id="PlaceItem"
        onClose={() => handleModal(false)}
        openHeight="low"
        open={openModal}
        variationModal="scrollAlone"
        maxModalHeight={550}
        blocking={false}
      >
        <S.SelectedWrapper>
          <PlaceItem
            key={`selected@${placeSelected.id}`}
            id={`selected@${placeSelected.id}`}
            place={placeSelected}
          />
        </S.SelectedWrapper>
      </ModalMobile>
    )}
  </S.SearchWrapper>
);
